<template>
    <div class="contain">

        <div class="col-sm-16 col-xs-22" style="position: relative; text-align: center">
          <div style="margin: 2rem 0 1rem" v-if="!needSubscribe" class="back-button cursor-pointer" @click="$router.push({ path: '/studentProfile' })">
              <i class="el-icon-back" style="margin-right: 0.25rem"></i>
              <div style="text-align: left; white-space: pre-wrap">
                  {{ "返回家長平台\n Back to parent platform" }}
              </div>
          </div>
          <div style="margin: 2rem 0 1rem" v-if="needSubscribe" class="back-button cursor-pointer" @click="$router.push({ path: '/register' })">
            <i class="el-icon-back" style="margin-right: 0.25rem"></i>
            <div style="text-align: left; white-space: pre-wrap">
              {{ "返回\n Back" }}
            </div>
          </div>
          <div style="margin: 5rem 0 1rem">
            {{ token == null ? "第 2 步，共 3 步 | Step 2 ,  Total 3 steps " : "第 1 步，共 2 步 | Step 1 ,  Total 2 steps " }}
          </div>
          <div style="margin: 2rem 0 1rem;font-size: 2rem; line-height: 2rem; font-weight: bold; color: #b62d2e; white-space: pre-wrap">
              {{ isRenew ? "網上平台續訂\n Renewal Subscription" : "網上平台訂閱\n Subscription" }}
          </div>
        </div>
        <div style="display: flex; margin-top: 0.5rem; margin-bottom: 1rem">
            <span style="width: 1rem; height: 1rem; background: #b62d2e; border-radius: 50%; margin: 0 0.5rem"></span>
            <span style="width: 1rem; height: 1rem; background: #de5934; border-radius: 50%; margin: 0 0.5rem"></span>
            <span style="width: 1rem; height: 1rem; background: #f1aa55; border-radius: 50%; margin: 0 0.5rem"></span>
        </div>
        <div class="col-xs-22 col-sm-13" style="text-align: center; white-space: pre-wrap">
            {{
                token == null
                    ? "完成註冊流程後，我們會透過電子郵件將家長平台密碼傳送給您。\nAfter completing the registration , we will send the login password via email."
                    : needSubscribe
                    ? "請完成訂閱流程\n Please complete the subscription process"
                    : ""
            }}
        </div>
        <div class="cart-box col-xs-22 col-sm-16">
            <el-form ref="form" :model="form" status-icon>
              <p style="color: #9b9b9b;font-size: 14px">家長電郵 Parent's Email：{{form.email}}|家長姓名 Parent's Name：{{form.name}}</p>
                <div class="cart-list" v-for="(item, index) in form.orderItems" :key="index">
                    <el-row type="flex" :gutter="20" class="student-box" :style="{ 'padding-bottom': isRenew ? '1.25rem' : '' }">
                        <el-col :xs="24" :sm="12" style="padding-top: 0.625rem">
                            <el-form-item :prop="'orderItems.' + index + '.userNo'" class="cart-list-name" :rules="ruleName">
                                <div class="input-title">學生登入名稱 Student Login</div>
                                <el-input v-if="!isRenew || item.isAdd" v-model="item.userNo"></el-input>
                                <el-select v-else v-model="item.userNo" :placeholder="$t('other.pleaseSelect')" style="width: 100%" :name="'select' + item.gradeId">
                                    <el-option
                                        v-for="(item2, index2) in detail.students"
                                        :key="index2"
                                        :label="item2.userNo + `${item2.subscriptions.length > 0 ? checkDate(item2.subscriptions[0].endDate) : '(未訂閱) Not subscribed'}`"
                                        :value="item2.userNo"
                                        :disabled="!!item2.studentCode || (item2.subscriptions.length > 0 ? checkDate(item2.subscriptions[0].endDate) == '(訂閱中) Subscribing' : false)"
                                        @click.native.capture="studentSelect(index, item2, index2)"
                                    >
                                        <span>{{ item2.userNo }}</span>
                                        <span>{{ item2.subscriptions.length > 0 ? `${checkDate(item2.subscriptions[0].endDate)}` : "(未訂閱) Not subscribed" }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" style="padding-top: 0.625rem">
                            <el-form-item :prop="'orderItems.' + index + '.gradeId'" class="cart-list-grade" :rules="ruleGrade">
                                <div class="input-title">年級 Level</div>
                                <el-select v-model="item.gradeId" @change="gradeChange(item.gradeId, index)" :placeholder="$t('other.pleaseSelect')" style="width: 100%">
                                    <el-option
                                        v-for="(item2, index2) in grades"
                                        :key="index2"
                                        :label="item2.name"
                                        :value="item2.id"
                                        :disabled="
                                            !item.isAdd &&
                                            isRenew &&
                                            studentIndex[index] &&
                                            detail.students[studentIndex[index] - 1].subscriptions.length > 0 &&
                                            detail.students[studentIndex[index] - 1].subscriptions[0].gradeId > item2.id
                                        "
                                    >
                                        <!-- :disabled="!isRenew?false:!studentIndex[index]?false:detail.students[studentIndex[index]].subscriptions.length==0?false:detail.students[studentIndex[index]].subscriptions[0].gradeId>=item2.id" -->
                                        <!-- :disabled="isRenew&&detail.students[studentIndex[index]].subscriptions&&detail.students[studentIndex[index]].subscriptions[0].gradeId>=item2.id" -->
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="item.isBranch" :xs="24" :sm="12" style="padding-top: 0.625rem">
                            <el-form-item :prop="'orderItems.' + index + '.studentCode'" :rules="ruleStudentCode">
                                <div class="input-title">分校學生編號 Student ID</div>
                                <el-input v-model="item.studentCode" placeholder="分校學生編號 Student ID (e.g. OLY1000)"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="item.isBranch" :xs="24" :sm="12" style="padding-top: 0.625rem">
                            <!-- :rules="rulePhone" -->
                            <el-form-item
                                :prop="'orderItems.' + index + '.studentCodePhone'"
                                :rules="[
                                    {
                                        required: true,
                                        message: '請輸入激活碼 Please enter activation code',
                                        trigger: 'blur',
                                    },
                                ]"
                            >
                                <div class="input-title">激活碼 Activation code</div>
                                <el-input v-model="item.studentCodePhone"></el-input>
                            </el-form-item>
                        </el-col>
                        <!-- v-if="!isRenew || item.isAdd" -->
                        <el-checkbox @change="branchChange(index, $event)" style="padding: 0.625rem; line-height: 1" v-model="item.isBranch"
                            >我是分校學生 I am a Center Student</el-checkbox
                        >
                    </el-row>
                    <div class="cart-list-operation">
                        <div>
                            <div>{{ item.isBranch ? "---" : addComma(item.price) }}</div>
                            <div v-if="item.price != null" style="color: #8e8e8e">
                                {{ showDate(item.startDate) }}
                            </div>
                        </div>
                        <div>
                            <i class="el-icon-delete cursor-pointer" style="padding: 0.5rem" @click="onIconMetroBin(index)"></i>
                        </div>
                    </div>
                </div>
            </el-form>
            <div class="cart-list">
                <div class="list-add cursor-pointer" @click="addSubscription"><i class="el-icon-circle-plus-outline" style="margin-right: 0.25rem"></i>增加學生 Add Student</div>
            </div>
            <el-row type="flex" style="flex-wrap: wrap" :gutter="20" class="summary-box">
                <el-col :xs="24" :sm="12" style="padding-top: 0.625rem; padding-bottom: 1.25rem">
                    <div class="input-title" @change="usePromoCode">推廣碼 Promotion Code</div>
                    <el-input v-model="form.promotionCode" @input="isPromoCode = false">
                        <button class="cursor-pointer" slot="append" @click="usePromoCode">使用 Use</button>
                    </el-input>
                    <div v-if="isPromoCode && !codeError" style="color: #008000; line-height: 1.6rem">推廣碼已套用！Promotion code applied !</div>
                    <div v-else-if="isPromoCode && codeError" style="color: #d20000; line-height: 1.6rem">推廣碼錯誤！The promotion code is incorrect!</div>
                </el-col>
                <el-col :xs="24" :sm="12" style="padding-top: 0.625rem">
                    <div class="cart-summary">
                        <div style="font-weight: bold; font-size: 1.1rem">訂閱總結 Summary</div>
                        <div class="cart-summary-text" style="margin: 0.5rem 0">
                            <span>小計 Subtotal</span><span>{{ addComma(priceList[0]) }}</span>
                        </div>
                        <div class="cart-summary-text" style="margin: 0.5rem 0">
                            <span>折扣 Discount</span><span>{{ addComma(priceList[1], 1) }}</span>
                        </div>
                        <el-divider></el-divider>
                        <div class="cart-summary-text" style="margin: 0.5rem 0">
                            <span>總計 Total</span><span>{{ addComma(priceList[2]) }}</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <div style="display: flex; flex-direction: column; margin: 3rem 0">
              <el-button
                  :disabled="loading"
                  round
                  @click="checkout"
                  class="security-button cursor-pointer"
                  :loading="loading"
              loading-text="Loading..."
              >
              <span v-if="!loading">前往結帳 Checkout</span>
              <span v-else>處理中 Processing...</span>
              </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { getProfile, putProfile, searchUser } from "@/api/user";
import { getGrades } from "@/api/grade";
import { verifyStudentCode } from "@/api/setting";
import { getPromotionCodes, addOrders, paySkip } from "@/api/order";
import { register2} from "@/api/security";
import { setUserInfo, getUserInfo } from "@/utils/auth";
import { formatDate, formatDate2 } from "@/filters";
import moment from "moment";
export default {
    data() {
        // var validatePhone=(rule,value,callback)=>{
        //   if(this.form.phone && value !== this.form.phone){
        //     callback(new Error('錯誤激活碼'))
        //   } else {
        //     callback();
        //   }
        // };
        // var validateStudentCode=(rule,value,callback)=>{
        //   if(!value){
        //     callback(new Error('請輸入學生編號'))
        //   } else if(this.getVerify()) {
        //     callback();
        //   } else {
        //     callback(new Error(''))
        //   }
        // };
        var validateName = (rule, value, callback) => {
            if (value == this.form.userNo) {
                callback(new Error("學生帳戶不能與家長郵箱重複 Student account cannot be duplicated with parent's email address."));
                // }else if(!this.isRenew&&this.detail.students.findIndex((v)=>v.userNo==value)>-1){
                //   callback(new Error('該帳戶名稱已存在。'));
            } else if (/^[A-Za-z0-9.]{8,16}$/.test(value)) {
              if(value==null){
                callback(new Error("學生帳戶名稱不能為空。Student account name is required."));
                return
              }
                if (!this.isRenew || this.form.orderItems[rule.field.split(".")[1]].isAdd) {
                    searchUser({ userNo: value }).then((v) => {
                        if (v.data > 0) {
                            callback(new Error("學生帳戶名稱已被註冊。Student account name has been registered."));
                        } else callback();
                    });
                } else callback();
            } else {
                callback(
                    new Error(
                        "學生登入名稱必須介於 8-16 個字元之間。它可以包含字母 (a-z)、數字 (0-9) 和句點 (.)。\nThe Student Login must be between 8-16 characters long. It can contain letters (a-z), numbers (0-9), and periods (.)."
                    )
                );
            }
        };
        return {
            id: 0,
            isRenew: false,
            needSubscribe: false,
            form: {
                userNo: null,
                name: null,
                email: null,
                promotionCode: null,
                phone: null,
                orderItems: [
                    {
                        isAdd: true,
                        id: null,
                        gradeId: null,
                        userNo: null,
                        studentCode: null,
                        studentCodePhone: null,
                        showPassword: false,
                        isBranch: false,
                        price: null,
                        startDate: null,
                    },
                ],
            },
            studentIndex: [""],
            codeError: false,
            discount: null,
            isPromoCode: false,
            grades: [],
            ruleGrade: [
                {
                    required: true,
                    message: "請選擇年級 Please select a grade",
                    trigger: "blur",
                },
            ],
            ruleName: [{ validator: validateName, trigger: "blur" }],
            ruleStudentCode: [
                {
                    required: true,
                    message: "請輸入學生編號 Please enter student number",
                    trigger: "blur",
                },
            ],
            // ruleStudentCode:[{validator: validateStudentCode, trigger: 'blur'}],
            // rulePhone:[{validator: validatePhone, trigger: 'blur'}],
            detail: {
                students: [],
            },
            loading: false,
            existIndex: null,
            studentCodesId: [], //分校列表
        };
    },
    computed: {
        priceList() {
            var sum = 0;
            var discount = 0;
            var total = 0;
            this.form.orderItems
                .filter((v) => !v.isBranch)
                .forEach((item) => {
                    sum += Number(item.price);
                });
            if (this.discount) discount = (sum / 100) * (100 - this.discount);
            else if (this.discount == 0) discount = sum;
            total = sum - discount;
            return [sum, discount, total];
        },
    },
    created() {
        this.getGrades();
        // if(!this.isEmpty(this.$route.query.id))this.id=Number(this.$route.query.id)
        if (!this.isEmpty(this.$route.query.isRenew) && this.$route.query.isRenew != "false") this.isRenew = Boolean(this.$route.query.isRenew);
        if (!this.isEmpty(this.$route.query.needSubscribe) && this.$route.query.needSubscribe != "false") this.needSubscribe = Boolean(this.$route.query.needSubscribe);
        if (!this.isEmpty(this.$route.query.email)) {
            this.form.email = this.$route.query.email;
            this.form.userNo = this.$route.query.email;
        }
        if (!this.isEmpty(this.$route.query.name)) this.form.name = this.$route.query.name;
        if (this.token != null && this.userInfo && this.userInfo.roleName == this.roleNameParent) this.getProfile();
    },
    methods: {
        enName(gradeName) {
            let enGradeList = {
                小一: "Primary One",
                小二: "Primary Two",
                小三: "Primary Three",
                小四: "Primary Four",
                小五: "Primary Five",
                小六: "Primary Six",
            };
            return enGradeList[gradeName];
        },
        addComma(num, i) {
            if (i == 1) return num ? `- HKD $${num.toLocaleString()}` : "---";
            return num ? `HKD $${num.toLocaleString()}` : "---";
        },
        showDate(date) {
            var start = date || new Date();
            var end = new Date(start);
            end.setFullYear(end.getFullYear() + 1);
            end.setDate(end.getDate() - 1);
            return formatDate(start) + " - " + formatDate(end);
        },
        getThreeMonthAgo(endDate) {
            var a = moment();
            var b = moment(endDate);
            return b.diff(a, "months");
        },
        //0:30天外,订阅中；1:30天内,即将过期;2:过期
        checkDate(endDate) {
            let text = "(訂閱中) Subscribing";
            if (this.getThreeMonthAgo(endDate) <= 3) {
                text = "(即將過期) Expires soon";
            }
            if (moment().format("YYYY-MM-DD") == moment(endDate).format("YYYY-MM-DD")) {
                text = "(到期) Date of Expiry";
            }
            if (moment().format("YYYY-MM-DD") > moment(endDate).format("YYYY-MM-DD")) {
                text = "(過期) Expired";
            }
            return text;
        },
        studentSelect(i, item, index) {
            this.studentIndex[i] = index + 1;
            if (item.subscriptions.length > 0) {
                if (this.checkDate(item.subscriptions[0].endDate) == "(即將過期) Expires soon" || this.checkDate(item.subscriptions[0].endDate) == "(到期) Date of Expiry") {
                    let start = new Date(item.subscriptions[0].endDate);
                    start.setDate(start.getDate() + 1);
                    this.form.orderItems[i].startDate = start;
                } else this.form.orderItems[i].startDate = null;
            } else this.form.orderItems[i].startDate = null;
        },
        branchChange(index, e) {
            if (!e) {
                this.form.orderItems[index].studentCode = null;
                this.form.orderItems[index].studentCodePhone = null;
            }
        },
        getProfile() {
            this.detail = getUserInfo("userProfile");
            this.form.userNo = this.detail.userNo;
            this.form.phone = this.detail.phone;
            this.id = this.detail.id;
            if (this.isRenew) {
                this.detail.students.forEach((item, index) => {
                    if (item.status == 1 && !item.studentCode) {
                        if (item.subscriptions.length == 0) {
                            this.form.orderItems.push({
                                id: item.id,
                                gradeId: item.grade?.id,
                                userNo: item.userNo,
                                studentCode: item.studentCode || null,
                                studentCodePhone: null,
                                showPassword: false,
                                isBranch: false,
                                price: item.grade?.price,
                                startDate: new Date(),
                            });
                            this.studentIndex.push(index + 1);
                        } else if (this.checkDate(item.subscriptions[0].endDate) == "(即將過期) Expires soon" || this.checkDate(item.subscriptions[0].endDate) == "(到期) Date of Expiry") {
                            let start = new Date(item.subscriptions[0].endDate);
                            start.setDate(start.getDate() + 1);
                            this.form.orderItems.push({
                                id: item.id,
                                gradeId: item.subscriptions[0].subscribeAssignGrades.at(-1).id,
                                userNo: item.userNo,
                                studentCode: item.studentCode || null,
                                studentCodePhone: null,
                                showPassword: false,
                                isBranch: false,
                                price: item.subscriptions[0].subscribeAssignGrades.at(-1).price,
                                startDate: start,
                            });
                            this.studentIndex.push(index + 1);
                        } else if (this.checkDate(item.subscriptions[0].endDate) == "(過期) Expired") {
                            this.form.orderItems.push({
                                id: item.id,
                                gradeId: item.subscriptions[0].subscribeAssignGrades.at(-1).id,
                                userNo: item.userNo,
                                studentCode: item.studentCode || null,
                                studentCodePhone: null,
                                showPassword: false,
                                isBranch: false,
                                price: item.subscriptions[0].subscribeAssignGrades.at(-1).price,
                                startDate: new Date(),
                            });
                            this.studentIndex.push(index + 1);
                        }
                    }
                });
                this.$nextTick(() => {
                    this.onIconMetroBin(0);
                });
            }
        },
        getPromotionCodes() {
            getPromotionCodes({ code: this.form.promotionCode }).then((v) => {
                if (v.data.length > 0) {
                    let index = v.data.findIndex((item) => item.code == this.form.promotionCode);
                    if (index != -1) {
                        this.codeError = false;
                        this.discount = v.data[index].discount;
                    } else this.codeError = true;
                } else this.codeError = true;
                this.isPromoCode = true;
            });
        },
        gradeChange(id, index) {
            this.form.orderItems[index].price = this.grades.find((item) => item.id == id).price;
            if (!this.form.orderItems[index].startDate) this.form.orderItems[index].startDate = new Date();
            this.$refs.form.validate();
        },
        addSubscription() {
            this.form.orderItems.push({
                isAdd: true,
                id: null,
                gradeId: null,
                userNo: null,
                studentCode: null,
                studentCodePhone: null,
                showPassword: false,
                isBranch: false,
                price: null,
                startDate: null,
            });
            this.studentIndex.push("");
        },
        getGrades() {
            getGrades().then((v) => {

                this.grades = v.data;
              //過濾掉4、5、6
              //   this.grades = v.data.filter(item => item.id < 4);
            });
        },
        onIconMetroBin(index) {
            if (this.form.orderItems.length > 1) {
                this.form.orderItems.splice(index, 1);
                this.studentIndex.splice(index, 1);
                this.$nextTick(() => {
                    this.$refs.form.validate();
                });
            } else {
                this.addSubscription();
                this.onIconMetroBin(0);
            }
        },
        usePromoCode() {
            this.getPromotionCodes();
        },
        checkout() {

            this.existIndex = null;
            let reverseList = this.form.orderItems.slice().reverse(); //反转数据
            let reverseListFields = this.$refs.form.fields.slice().reverse(); //反转表单数据
            this.studentCodesId = [];
            let isExist = this.form.orderItems.some((item, index) => {
                let i = reverseList.findIndex((v) => v.userNo == item.userNo);
                i = reverseList.length - 1 - i; //最后一个相同学生账号的下标
                let errIndex = reverseListFields.findIndex((v) => v.fieldValue == item.userNo && v.prop.split(".")[2] == "userNo");
                errIndex = reverseListFields.length - 1 - errIndex; //表单最后一个相同学生账号的下标
                let j = this.$refs.form.fields.findIndex((v) => v.fieldValue == item.userNo && v.prop.split(".")[2] == "userNo"); //表单第一个相同学生账号的下标
                if (i != index) {
                    this.existIndex = errIndex;
                    this.$refs.form.fields[this.existIndex].validateState = "error";
                    this.$refs.form.fields[this.existIndex].validateMessage = "該帳戶名稱已添加。The account name has been added.";
                    return true;
                } else if (item.isAdd && this.detail.students.findIndex((v) => v.userNo == item.userNo) > -1) {
                    this.existIndex = j;
                    this.$refs.form.fields[this.existIndex].validateState = "error";
                    this.$refs.form.fields[this.existIndex].validateMessage = "該帳戶名稱已添加。The account name has been added.";
                    return true;
                } else {
                    return false;
                }
            });
            let studentCodeExist = this.form.orderItems
                .filter((v) => v.studentCode)
                .some((item, index) => {
                    let i = reverseList.findIndex((v) => v.studentCode == item.studentCode);
                    i = reverseList.length - 1 - i; //最后一个相同分校编号的下标
                    let errIndex = reverseListFields.findIndex((v) => v.fieldValue == item.studentCode && v.prop.split(".")[2] == "studentCode");
                    errIndex = reverseListFields.length - 1 - errIndex; //表单最后一个相同学生账号的下标
                    let j = this.$refs.form.fields.findIndex((v) => v.fieldValue == item.studentCode && v.prop.split(".")[2] == "studentCode"); //表单第一个相同学生账号的下标
                    if (i != index) {
                        this.$refs.form.fields[errIndex].validateState = "error";
                        this.$refs.form.fields[errIndex].validateMessage = "該分校學生編號已添加。The student ID has been added.";
                        return true;
                    } else if (item.isAdd && this.detail.students.findIndex((v) => v.userNo == item.userNo) > -1) {
                        this.$refs.form.fields[j].validateState = "error";
                        this.$refs.form.fields[j].validateMessage = "該分校學生編號已添加。The student ID has been added.";
                        return true;
                    } else {
                        return false;
                    }
                });
            if (!isExist && !studentCodeExist) {
                this.$refs.form.validate(async (valid) => {
                    if (valid) {
                        let isVerify = await this.getVerify();
                        if (!isVerify) {
                            this.loading = true;
                            if (this.token != null) {
                                let list = this.form.orderItems.filter((item) => {
                                    return this.detail.students.findIndex((v) => v.userNo == item.userNo) == -1;
                                });
                                if (list.length > 0){
                                  this.addStudent(list);
                                } else{
                                  this.subscribe(this.detail.students);
                                }
                            } else {
                              this.register();
                            }
                        } else {
                            // console.log("error submit!!");
                            return false;
                        }
                    }
                });
            }
        },
        //是否被验证过
        async getVerify() {
            let that = this;
            let result = false;
            for (let item of that.form.orderItems) {
                if (item.isBranch && item.studentCode && item.studentCodePhone) {
                    // try {
                        let codeExist = await verifyStudentCode({
                            number: item.studentCode,
                        });
                        if (codeExist?.data?.isExist) {
                            let phoneExist = await verifyStudentCode({
                                number: item.studentCode,
                                phone: item.studentCodePhone,
                            });
                            if (phoneExist?.data?.isExist) {
                                item.price = 0;
                                // that.studentCodesId.push(v.data[0].id);
                                that.studentCodesId.push(item.studentCodePhone);
                            } else {
                                let indexPhone = that.$refs.form.fields.findIndex((v) => v.fieldValue == item.studentCodePhone && v.prop.split(".")[2] == "studentCodePhone");
                                that.$refs.form.fields[indexPhone].validateState = "error";
                                that.$refs.form.fields[indexPhone].validateMessage = "錯誤激活碼 Wrong Activation Code";
                                result = true;
                            }
                        } else {
                            let indexCode = that.$refs.form.fields.findIndex((v) => v.fieldValue == item.studentCode && v.prop.split(".")[2] == "studentCode");
                            that.$refs.form.fields[indexCode].validateState = "error";
                            that.$refs.form.fields[indexCode].validateMessage = "錯誤分校學生編號 Wrong Student ID";
                            result = true;
                        }
                    // } catch (error) {
                    //     if (error.response&&error.response.data.error_message=='分校學生編號已被註冊') {
                    //         let indexCode = that.$refs.form.fields.findIndex((v) => v.fieldValue == item.studentCode && v.prop.split(".")[2] == "studentCode");
                    //         that.$refs.form.fields[indexCode].validateState = "error";
                    //         that.$refs.form.fields[indexCode].validateMessage = "分校學生編號已被註冊";
                    //     } else {
                    //         this.$message.error(error.response.data.error_message);
                    //     }
                    //     result = true;
                    // }
                }
            }
            return result;
        },

        register() {
          //彈出確認
          this.$confirm("Email:"+this.form.email, "確認Email並前往下一步？\nCreate Account & Checkout?", {
            confirmButtonText: "確定 Confirm",
            cancelButtonText: "取消 Back",
            center: true,
            showClose: false,
            closeOnClickModal: false,
            customClass: "exit-box",
            cancelButtonClass: "exit-cancel",
            confirmButtonClass: "exit-confirm",
          }).then(() => {
            let students = this.form.orderItems.map((item) => {
              return {
                userNo: item.userNo,
                gradeId: item.gradeId,
                studentCode: item.studentCode,
                studentCodePhone: item.studentCodePhone,
              };
            });
            let form = {
              userNo: this.form.userNo,
              name: this.form.name,
              email: this.form.email,
              students,
            };
            register2(form)
                .then((v) => {
                  // 接口请求成功（HTTP 200）但业务失败的情况
                  // 注：如果接口返回非200 HTTP状态码，会直接进入catch分支
                  if (v.data.error_code) {
                    // 有错误码=业务失败，弹出具体错误提示
                    const errorMsg = v.data.error_message || "創建賬戶失敗！Create account failed!";
                    this.$message.error(errorMsg);
                    this.loading = false;
                    return;
                  }
                  // 无错误码=业务成功，执行后续逻辑
                  this.id = v.data.id;
                  this.subscribe(v.data.students);
                })
                .catch(() => {
                  this.loading = false;
                });
          }).catch(() => {
            // 取消按钮/关闭弹窗逻辑：设置loading为false
            this.loading = false;
          });

            // .catch((err)=>{
            //   this.existIndex = err.response.data.error_message.split(" ")[1].split('.')[1]
            //   this.$refs.form.fields[2*this.existIndex].validateState='error'
            //   this.$refs.form.fields[2*this.existIndex].validateMessage='學生帳戶名稱已被註冊。'

            // })
        },
        addStudent(list) {
            let form = JSON.parse(JSON.stringify(this.detail));
            list.forEach((item) => {
                form.students.push({
                    userNo: item.userNo,
                    gradeId: item.gradeId,
                    studentCode: item.studentCode,
                    studentCodePhone: item.studentCodePhone,
                    // avatar:'',
                    // gender:null,
                    grade: this.grades[item.gradeId - 1], //this.grades.find(v=>v.id==item.gradeId)
                });
            });
            putProfile(form).then(() => {
                getProfile().then((v) => {
                    setUserInfo("userProfile", v.data);
                    this.subscribe(v.data.students);
                });
            });
            // .catch((err)=>{
            //   let userNo=err.response.data.error_message.split(" ")[0]
            //   this.existIndex=this.form.orderItems.findIndex((item)=>{
            //     return item.userNo==userNo
            //   })
            //   this.$refs.form.fields[2*this.existIndex].validateState='error'
            //   this.$refs.form.fields[2*this.existIndex].validateMessage='學生帳戶名稱已被註冊。'
            //   this.loading=false
            // })
        },
        subscribe(list) {
            let orderItems = this.form.orderItems.map((item) => {
                let temp = list.find((item2) => item2.userNo == item.userNo);
                return {
                    studentId: temp.id,
                    gradeId: item.gradeId,
                    price: Number(item.price),
                    startDate: formatDate2(item.startDate),
                    studentCode: item.studentCode,
                    studentCodePhone: item.studentCodePhone,
                    isBranch:item.isBranch
                };
            });
            let form = {
                parentId: this.id,
                totalPrice: Number(this.priceList[0]),
                payPrice: Number(this.priceList[2]), //this.studentCodesId.length>0 ? 0:
                promotionCode: this.form.promotionCode,
                orderItems,
            };
            addOrders(form)
                .then((v) => {
                    if (this.discount == 0) {
                        paySkip(v.data.id).then(() => {
                            this.$router.push({
                                path: `/checkout?orderId=${v.data.id}&isRenew=${this.isRenew}&isSubscribe=${this.token != null}&status=succeeded`,
                            });
                        });
                    }
                    if (this.studentCodesId.length > 0 && this.discount != 0) {
                        if (form.payPrice == 0) {
                            paySkip(v.data.id).then(() => {
                                this.$router.push({
                                    path: `/checkout?orderId=${v.data.id}&isRenew=${this.isRenew}&isSubscribe=${this.token != null}&status=succeeded`,
                                });
                            });
                        } else {
                            this.$router.push({
                                path: `/payment?orderId=${v.data.id}&isRenew=${this.isRenew}`,
                            });
                        }
                    }
                    if (this.studentCodesId.length == 0 && this.discount != 0)
                        this.$router.push({
                            path: `/payment?orderId=${v.data.id}&isRenew=${this.isRenew}`,
                        });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.contain {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.back-button {
    position: absolute;
    left: 0;
    display: flex;
}
.cart-box {
    padding: 1.25rem 0;
}
.cart-list {
    border-top: 1px #a1a1a166 solid;
    padding: 0.625rem 0;
    display: flex;
}
.student-box {
    display: flex;
    flex-wrap: wrap;
    flex: 2;
}
.input-title {
    color: #8e8e8e;
    font-weight: bold;
    line-height: 1.6rem;
}
.cart-list-operation {
    display: flex;
    justify-content: space-between;
    line-height: 2;
    flex: 1;
    margin-top: 1.25rem;
    margin-left: 5rem;
}
.list-add {
    margin: 1.5rem 0;
    border: 1px dashed #8e8e8e;
    flex: 1;
    padding: 1.25rem;
    text-align: center;
    color: #8e8e8e;
    font-weight: bold;

    //border: 1px solid transparent;
    //background: linear-gradient(white,white) padding-box,repeating-linear-gradient(-45deg,#8E8E8E 0, #8E8E8E 0.5em,white 0,white 1em);
}
.summary-box {
    display: flex;
    flex-wrap: wrap;
}
.cart-summary {
    background-color: #f1aa551a;
    border-radius: 1.25rem;
    padding: 1.25rem;
}
.cart-summary-text {
    display: flex;
    justify-content: space-between;
}
.security-button {
    border: 0.0625rem solid #fcc03a;
    font-weight: bold;
    font-size: 1.125rem;
    color: #444444;
    background-color: #fcc03a;
    &.is-disabled {
        background-color: #ffffff;
    }
}

@media (min-width: $minWidth) and (max-width: $maxWidth) {
    .security-box {
        width: 26rem;
    }
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .contain {
        height: 100%;
    }
    .back-button {
        position: static;
        text-align: left;
    }
    .cart-list {
        flex-direction: column;
    }
    .cart-list-operation {
        margin-left: 0;
    }
}
::v-deep {
    .el-select .el-input .el-select__caret {
        color: #444444;
    }
    /*.el-select [name="select4"] {
    color: red;
  }*/
    .el-input__inner {
        //border-top-right-radius: 3.125rem;
        //border-bottom-right-radius: 3.125rem;
        border-radius: 0.625rem;
        //background-color: #fffbed;
        border: 0.0625rem solid #a1a1a1;
        padding-left: 0.5rem;
        height: 2.75rem;
        line-height: 2.75rem;
    }
    .summary-box .el-input__inner {
        border-radius: 0.625rem 0 0 0.625rem;
        //background-color: #fffbed;
        border: 0.0625rem solid #a1a1a1;
        border-right: none;
        padding-left: 0.5rem;
        height: 2.75rem;
        line-height: 2.75rem;
    }
    .summary-box .el-input-group__append {
        border-radius: 0 0.625rem 0.625rem 0;
        background-color: #ffffff;
        border: 0.0625rem solid #a1a1a1;
        border-left: none;
        padding: 0.25rem;

        button {
            border: 0.0625rem solid #fcc03a;
            background-color: #fcc03a;
            border-radius: 0.5rem;
            height: 2.125rem;
            padding: 0 1.5rem;
        }
    }
    .el-checkbox__inner {
        border-color: #a1a1a1;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #444444;
    }
    .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #a1a1a1;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #00800014;
        border-color: #008000;
        &::after {
            border-color: #008000;
        }
    }
    .el-form-item {
        margin-bottom: 0;
    }
    .el-form-item__error {
        font-size: 14px;
        line-height: 1.6;
        padding-top: 0;
        position: relative;
    }
    .cart-list-name.el-form-item.is-error,
    .cart-list-grade.el-form-item.is-error {
        .el-icon-circle-close {
            display: none;
        }
        /* .el-input__inner {
            border-color: #f1aa55;
        }
        .el-form-item__error {
            color: #8e8e8e;
        } */
    }
    .el-input__icon {
        width: 1.75rem;
        line-height: 2.75rem;
    }
    .el-icon-view {
        vertical-align: top;
    }
    .el-icon-circle-close {
        font-size: 1.75rem;
    }
    .el-icon-circle-check {
        color: #008000;
        font-size: 1.75rem;
        vertical-align: middle;
    }
    .cart-list-grade .el-icon-circle-check {
        display: none;
    }
    .el-button + .el-button {
        margin: 0;
        margin-top: 1.125rem;
    }
    .el-divider--horizontal {
        margin: 0.5rem 0;
    }
}
</style>